<template>
  <div v-if="currentProfil">
    <SharedCompetence
      :currentEmploye="currentProfil.employe"
      :competencableUuid="currentProfil.session.formation.uuid"
      :competencableType="competencableType"
      @onRefresh="refresh"
    />
  </div>
</template>

<script>
import SharedCompetence from '@/views/rh/shared/competence/List';
import URL_P from '@/http/rh/formation/profil';
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      competencableType: 'formations',
    };
  },
  components: {
    SharedCompetence,
  },
  computed: {
    ...mapGetters('profilParticipant', ['currentProfil']),
  },

  methods: {
    ...mapActions('profilParticipant', ['setCurrentProfil']),
    refresh() {
      this.setCurrentProfil(null);

      window.axios
        .get(URL_P.PROFIL + '/' + this.$route.params.profilId, {
          params: {
            edit: false,
          },
        })
        .then((resp) => {
          this.setCurrentProfil(resp.data.profil);
        });
    },
  },
};
</script>

<style scoped></style>
